<template lang="pug">
  .content-wrap.dashboard
    .section
      .container
        sender(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
        receiver(v-else)
</template>

<script>
import sender from './sender'
import receiver from './receiver'
import {mapGetters} from 'vuex'
import { gettext } from './../../services/TranslateHandler'

const CONSTANTS = require('@/constants.json')

export default {
  name: 'Dashboard',
  metaInfo () {
    return {
      title: gettext('Dashboard'),
      titleTemplate: null,
      link: [
        {rel: 'canonical', href: document.location.origin + document.location.pathname}
      ]
    }
  },
  components: {
    sender,
    receiver
  },
  data () {
    return {
      CONSTANTS: CONSTANTS
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/dashboard/index.vue